export enum ErrorCode {
  // Generic
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  INVALID_STRING = 'INVALID_STRING',
  INVALID_BOOLEAN = 'INVALID_BOOLEAN',
  INVALID_ENUM = 'INVALID_ENUM',
  INVALID_NUMBER = 'INVALID_NUMBER',
  INVALID_INPUT = 'INVALID_INPUT',
  INVALID_EMAIL = 'INVALID_EMAIL',
  REQUIRED_FIELD = 'REQUIRED_FIELD',
  PAGE_SIZE_INVALID = 'PAGE_SIZE_INVALID',
  PAGE_INVALID = 'PAGE_INVALID',

  // Client
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  BAD_REQUEST = 'BAD_REQUEST',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  NOT_FOUND = 'NOT_FOUND',
  BAD_GATEWAY = 'BAD_GATEWAY',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',

  // Server
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',

  // Company
  COMPANY_NAME_EXISTS = 'COMPANY_NAME_EXISTS',
  COMPANY_COMMERCIAL_REGISTER_EXISTS = 'COMPANY_COMMERCIAL_REGISTER_EXISTS',
  COMPANY_EMAIL_EXISTS = 'COMPANY_EMAIL_EXISTS',
  COMPANY_PHONE_EXISTS = 'COMPANY_PHONE_EXISTS',
  COMPANY_NUM_CNPS_EXISTS = 'COMPANY_NUM_CNPS_EXISTS',
  COMPANY_NUM_NUI_EXISTS = 'COMPANY_NUM_NUI_EXISTS',

  // Payslip
  PAYSLIP_GENERATION_ERROR = 'PAYSLIP_GENERATION_ERROR',
  COMPANY_CREATION_FAILED = 'COMPANY_CREATION_FAILED',
  STAFF_PERIOD_ALLOWANCE_ALREADY_EXISTS = 'STAFF_PERIOD_ALLOWANCE_ALREADY_EXISTS',

  //Staff invoice
  CANNOT_APPROVE_STAFF_INVOICE_IN_CLOSED_PAY_PERIOD = 'CANNOT_APPROVE_STAFF_INVOICE_IN_CLOSED_PAY_PERIOD',
  COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND',
  ACCOUNTING_PERIOD_NOT_FOUND = 'ACCOUNTING_PERIOD_NOT_FOUND',
  ALREADY_CLOSED = 'ACCOUNTING_PERIOD_ALREADY_CLOSED',
  ACCOUNTING_PERIOD_OVERLAPPING = 'ACCOUNTING_PERIOD_OVERLAPPING',
  ACCOUNTING_PERIOD_INVALID_DATES = 'ACCOUNTING_PERIOD_INVALID_DATES',
  ACCOUNTING_PERIOD_INVALID_MONTH = 'ACCOUNTING_PERIOD_INVALID_MONTH',
  BANK_RECORD_ALREADY_ASSIGNED = 'ACCOUNTING_PERIOD_BANK_RECORD_ALREADY_ASSIGNED',
  COMPANY_ID_REQUIRED = 'ACCOUNTING_PERIOD_COMPANY_ID_REQUIRED',
  ACCOUNTING_PERIOD_TRANSACTION_NOT_FOUND = 'ACCOUNTING_PERIOD_TRANSACTION_NOT_FOUND',
  SECURE_ACCESS_TOKEN_INVALID = 'SECURE_ACCESS_TOKEN_INVALID',
  SECURE_ACCESS_TOKEN_EXPIRED = 'SECURE_ACCESS_TOKEN_EXPIRED',
  SECURE_ACCESS_TOKEN_MISSING = 'SECURE_ACCESS_TOKEN_MISSING',
  SECURE_ACCESS_OTP_INVALID = 'SECURE_ACCESS_OTP_INVALID',
  SECURE_ACCESS_OTP_EXPIRED = 'SECURE_ACCESS_OTP_EXPIRED',
  SECURE_ACCESS_OTP_REQUIRED = 'SECURE_ACCESS_OTP_REQUIRED',
  SECURE_ACCESS_RESOURCE_NOT_PROVIDED = 'SECURE_ACCESS_RESOURCE_NOT_PROVIDED',
  PAY_PERIOD_NOT_FOUND = 'PAY_PERIOD_NOT_FOUND',

  // Auth / Cognito
  COGNITO_INVALID_GRANT = 'COGNITO_INVALID_GRANT',
  NO_PAY_PERIOD_EDITORS_EMAILS_CONFIGURED = 'NO_PAY_PERIOD_EDITORS_EMAILS_CONFIGURED',

  // Auth - User
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  USER_NOT_CONFIRMED = 'USER_NOT_CONFIRMED',
  INVALID_VERIFICATION_CODE = 'INVALID_VERIFICATION_CODE',
  VERIFICATION_CODE_EXPIRED = 'VERIFICATION_CODE_EXPIRED',
  INVALID_PASSWORD_FORMAT = 'INVALID_PASSWORD_FORMAT',

  // Auth - Invitation
  INVITATION_TOKEN_NOT_FOUND = 'INVITATION_TOKEN_NOT_FOUND',
  INVITATION_TOKEN_EXPIRED = 'INVITATION_TOKEN_EXPIRED',
  USER_ALREADY_CONFIRMED = 'USER_ALREADY_CONFIRMED',

  // Auth - Federated
  ACCOUNT_LINKING_FAILED = 'ACCOUNT_LINKING_FAILED',

  // Staff
  STAFF_NOT_FOUND = 'STAFF_NOT_FOUND',
  STAFF_MUST_HAVE_CONTRACT = 'STAFF_MUST_HAVE_CONTRACT',
  STAFF_LIMIT_REACHED = 'STAFF_LIMIT_REACHED',
  CNPS_NUMBER_ALREADY_ASSIGNED = 'CNPS_NUMBER_ALREADY_ASSIGNED',

  // Contract
  CONTRACT_NOT_FOUND = 'CONTRACT_NOT_FOUND',
  CONTRACT_ALREADY_ONGOING = 'CONTRACT_ALREADY_ONGOING',
  CONTRACT_SUSPENDED = 'CONTRACT_SUSPENDED',
  CDI_CONTRACT_NO_END_DATE = 'CDI_CONTRACT_NO_END_DATE',

  // Pay Period
  PAY_PERIOD_NOT_CLOSED = 'PAY_PERIOD_NOT_CLOSED',
  PAY_PERIOD_ALREADY_EXISTS = 'PAY_PERIOD_ALREADY_EXISTS',
  PAY_PERIOD_ALREADY_CLOSED = 'PAY_PERIOD_ALREADY_CLOSED',
  PENDING_LEAVE_REQUESTS = 'PENDING_LEAVE_REQUESTS',

  // Payslip
  PAYSLIP_NOT_FOUND = 'PAYSLIP_NOT_FOUND',
  CANNOT_MODIFY_CONTRACT_ALLOWANCE = 'CANNOT_MODIFY_CONTRACT_ALLOWANCE',

  // Staff Request
  STAFF_REQUEST_NOT_FOUND = 'STAFF_REQUEST_NOT_FOUND',
  STAFF_REQUEST_DUPLICATE = 'STAFF_REQUEST_DUPLICATE',
  STAFF_REQUEST_OVERTIME_DURATION_EXCEEDED = 'STAFF_REQUEST_OVERTIME_DURATION_EXCEEDED',
  STAFF_REQUEST_INSUFFICIENT_LEAVE_DAYS = 'STAFF_REQUEST_INSUFFICIENT_LEAVE_DAYS',
  STAFF_REQUEST_ALREADY_APPROVED = 'STAFF_REQUEST_ALREADY_APPROVED',
  STAFF_REQUEST_ALREADY_DECLINED = 'STAFF_REQUEST_ALREADY_DECLINED',
  STAFF_REQUEST_ATTACHMENT_INVALID = 'STAFF_REQUEST_ATTACHMENT_INVALID',
  STAFF_REQUEST_PAY_PERIOD_CLOSED = 'STAFF_REQUEST_PAY_PERIOD_CLOSED',

  // Payroll Element
  PAYROLL_ELEMENT_NOT_FOUND = 'PAYROLL_ELEMENT_NOT_FOUND',

  // Payroll Variable
  PAYROLL_VARIABLE_ALREADY_EXISTS = 'PAYROLL_VARIABLE_ALREADY_EXISTS',
  PAYROLL_VARIABLE_NOT_FOUND = 'PAYROLL_VARIABLE_NOT_FOUND',
  PAYROLL_VARIABLE_INVALID_COLUMN_KEYS = 'PAYROLL_VARIABLE_INVALID_COLUMN_KEYS',
  PAYROLL_SESSION_NOT_FOUND = 'PAYROLL_SESSION_NOT_FOUND',
  PAYROLL_VARIABLE_PAY_PERIOD_CLOSED = 'PAYROLL_VARIABLE_PAY_PERIOD_CLOSED',

  // Subscription
  SUBSCRIPTION_MISSING_FIELDS = 'SUBSCRIPTION_MISSING_FIELDS',
  SUBSCRIPTION_INVALID_PLAN = 'SUBSCRIPTION_INVALID_PLAN',
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',

  // Team
  TEAM_NAME_REQUIRED = 'TEAM_NAME_REQUIRED',

  // Members / User-Company
  USER_CANNOT_MANAGE_OWN_ACCOUNT = 'USER_CANNOT_MANAGE_OWN_ACCOUNT',
  USER_NOT_ACTIVATED = 'USER_NOT_ACTIVATED',
  STAFF_ALREADY_INVITED = 'STAFF_ALREADY_INVITED',
  USER_COMPANY_ALREADY_EXISTS = 'USER_COMPANY_ALREADY_EXISTS',
  SINGLE_TRIAL_CONSTRAINT = 'SINGLE_TRIAL_CONSTRAINT',

  // Loan Request
  LOAN_REQUEST_NOT_FOUND = 'LOAN_REQUEST_NOT_FOUND',
  LOAN_REQUEST_CANNOT_BE_MODIFIED = 'LOAN_REQUEST_CANNOT_BE_MODIFIED',

  // Staff Invoice
  STAFF_INVOICE_NO_ITEMS = 'STAFF_INVOICE_NO_ITEMS',
  STAFF_INVOICE_MISSING_FIELDS = 'STAFF_INVOICE_MISSING_FIELDS',
  STAFF_INVOICE_DUPLICATE_ITEM = 'STAFF_INVOICE_DUPLICATE_ITEM',
  STAFF_INVOICE_INVALID_CONTRACT_TYPE = 'STAFF_INVOICE_INVALID_CONTRACT_TYPE',
  STAFF_INVOICE_INVALID_STATUS = 'STAFF_INVOICE_INVALID_STATUS',
  STAFF_INVOICE_NO_ATTACHMENT = 'STAFF_INVOICE_NO_ATTACHMENT',
  STAFF_INVOICE_ITEM_INVALID_QUANTITY = 'STAFF_INVOICE_ITEM_INVALID_QUANTITY',
  STAFF_INVOICE_ITEM_NOT_FOUND = 'STAFF_INVOICE_ITEM_NOT_FOUND',
  STAFF_INVOICE_ITEM_LAST_ITEM = 'STAFF_INVOICE_ITEM_LAST_ITEM',

  // CNPS Declaration
  CNPS_DECLARATION_NOT_FOUND = 'CNPS_DECLARATION_NOT_FOUND',
  CNPS_DECLARATION_ALREADY_DECLARED = 'CNPS_DECLARATION_ALREADY_DECLARED',
  CNPS_DECLARATION_PAY_PERIOD_OPEN = 'CNPS_DECLARATION_PAY_PERIOD_OPEN',
  CNPS_DECLARATION_ALREADY_PAID = 'CNPS_DECLARATION_ALREADY_PAID',
  CNPS_DECLARATION_CANNOT_REDECLARE = 'CNPS_DECLARATION_CANNOT_REDECLARE',
  CNPS_DECLARATION_MUST_DECLARE_FIRST = 'CNPS_DECLARATION_MUST_DECLARE_FIRST',
  CNPS_DECLARATION_COMPLEMENTARY_NO_INITIAL = 'CNPS_DECLARATION_COMPLEMENTARY_NO_INITIAL',
  CNPS_DECLARATION_COMPLEMENTARY_NOT_READY = 'CNPS_DECLARATION_COMPLEMENTARY_NOT_READY',
  CNPS_DECLARATION_DIPE_NOT_FOUND = 'CNPS_DECLARATION_DIPE_NOT_FOUND',

  // CNPS Declaration Detail
  CNPS_DECLARATION_DETAIL_COMPANY_REQUIRED = 'CNPS_DECLARATION_DETAIL_COMPANY_REQUIRED',
  CNPS_DECLARATION_DETAIL_ALREADY_EXISTS = 'CNPS_DECLARATION_DETAIL_ALREADY_EXISTS',
  CNPS_DECLARATION_DETAIL_NOT_FOUND = 'CNPS_DECLARATION_DETAIL_NOT_FOUND',
  CNPS_DECLARATION_DETAIL_PAYSLIP_NOT_FOUND = 'CNPS_DECLARATION_DETAIL_PAYSLIP_NOT_FOUND',

  // Declaration Period
  DECLARATION_PERIOD_NOT_FOUND = 'DECLARATION_PERIOD_NOT_FOUND',
  DECLARATION_PERIOD_ALREADY_CLOSED = 'DECLARATION_PERIOD_ALREADY_CLOSED',

  // Tax Declaration
  TAX_DECLARATION_NOT_FOUND = 'TAX_DECLARATION_NOT_FOUND',
  COMPANY_ACTIVITY_TYPE_MISSING = 'COMPANY_ACTIVITY_TYPE_MISSING',
  COMPANY_PAYMENT_METHOD_MISSING = 'COMPANY_PAYMENT_METHOD_MISSING',
  COMPANY_MUNICIPALITY_MISSING = 'COMPANY_MUNICIPALITY_MISSING',

  // Account
  ACCOUNT_DATA_MISSING = 'ACCOUNT_DATA_MISSING',
  ACCOUNT_NUMBER_EXISTS = 'ACCOUNT_NUMBER_EXISTS',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  ACCOUNT_PROVIDER_NOT_FOUND = 'ACCOUNT_PROVIDER_NOT_FOUND',
  ACCOUNT_PROVIDER_ALREADY_EXISTS = 'ACCOUNT_PROVIDER_ALREADY_EXISTS',
  ACCOUNT_PROVIDER_NOT_BUSINESS = 'ACCOUNT_PROVIDER_NOT_BUSINESS',
  ACCOUNT_BANK_CANNOT_UPDATE = 'ACCOUNT_BANK_CANNOT_UPDATE',
  ACCOUNT_BALANCE_CANNOT_UPDATE = 'ACCOUNT_BALANCE_CANNOT_UPDATE',
  ACCOUNT_UPDATE_NO_VALUES = 'ACCOUNT_UPDATE_NO_VALUES',

  // Credential (company secrets / IAM)
  CREDENTIAL_NOT_FOUND = 'CREDENTIAL_NOT_FOUND',
  CREDENTIAL_PURPOSE_ALREADY_EXISTS = 'CREDENTIAL_PURPOSE_ALREADY_EXISTS',

  // Document (storage)
  DOCUMENT_FILE_NOT_IN_STORAGE = 'DOCUMENT_FILE_NOT_IN_STORAGE',

  // Bank Record
  BANK_RECORD_NOT_FOUND = 'BANK_RECORD_NOT_FOUND',
  BANK_RECORD_READONLY_FIELDS = 'BANK_RECORD_READONLY_FIELDS',
  BANK_RECORD_INVALID_AMOUNT = 'BANK_RECORD_INVALID_AMOUNT',
  BANK_RECORD_INVALID_ACCOUNT_TYPE = 'BANK_RECORD_INVALID_ACCOUNT_TYPE',
  BANK_RECORD_LINK_INCOMPATIBLE = 'BANK_RECORD_LINK_INCOMPATIBLE',
  BANK_RECORD_LABEL_NOT_ATTACHED = 'BANK_RECORD_LABEL_NOT_ATTACHED',
  BANK_RECORD_INVALID_FORMAT = 'BANK_RECORD_INVALID_FORMAT',
  BANK_RECORD_DOCUMENT_NOT_FOUND = 'BANK_RECORD_DOCUMENT_NOT_FOUND',

  // Bank Statement
  BANK_STATEMENT_MULTI_MONTH = 'BANK_STATEMENT_MULTI_MONTH',
  BANK_STATEMENT_DOES_NOT_COVER_EXISTING = 'BANK_STATEMENT_DOES_NOT_COVER_EXISTING',
  BANK_STATEMENT_UNSUPPORTED_CONTENT_TYPE = 'BANK_STATEMENT_UNSUPPORTED_CONTENT_TYPE',
  BANK_STATEMENT_ACCOUNT_MISMATCH = 'BANK_STATEMENT_ACCOUNT_MISMATCH',
  BANK_STATEMENT_MISSING_ACCOUNT_INFO = 'BANK_STATEMENT_MISSING_ACCOUNT_INFO',

  // Record Label
  RECORD_LABEL_ALREADY_EXISTS = 'RECORD_LABEL_ALREADY_EXISTS',
  RECORD_LABEL_NOT_FOUND = 'RECORD_LABEL_NOT_FOUND',

  // Record Rule
  RECORD_RULE_ALREADY_EXISTS = 'RECORD_RULE_ALREADY_EXISTS',

  // Cycle Count
  CYCLE_COUNT_NOT_FOUND = 'CYCLE_COUNT_NOT_FOUND',
  CYCLE_COUNT_ACCOUNT_REQUIRED = 'CYCLE_COUNT_ACCOUNT_REQUIRED',
  CYCLE_COUNT_DATE_REQUIRED = 'CYCLE_COUNT_DATE_REQUIRED',
  CYCLE_COUNT_ALREADY_EXISTS_TODAY = 'CYCLE_COUNT_ALREADY_EXISTS_TODAY',
  CYCLE_COUNT_UNJUSTIFIED_TRANSACTIONS = 'CYCLE_COUNT_UNJUSTIFIED_TRANSACTIONS',
  CYCLE_COUNT_ALREADY_COMPLETED = 'CYCLE_COUNT_ALREADY_COMPLETED',
  CYCLE_COUNT_CANNOT_REGISTER_AMOUNT = 'CYCLE_COUNT_CANNOT_REGISTER_AMOUNT',
  CYCLE_COUNT_NOT_PARTICIPANT = 'CYCLE_COUNT_NOT_PARTICIPANT',

  // Accounting Book
  ACCOUNTING_BOOK_NOT_FOUND = 'ACCOUNTING_BOOK_NOT_FOUND',
  ACCOUNTING_BOOK_INVOICE_NOT_FOUND = 'ACCOUNTING_BOOK_INVOICE_NOT_FOUND',
}
